import { useState, useEffect } from 'react'
import { getRecentHistory, clearRecentHistory } from '@/apis/character'
import { userState } from '@/store/user'
import { useRecoilValue } from 'recoil'
import { DeleteOutlined } from '@ant-design/icons'
import TipsyModal from '../modal/TipsyModal'
import useSWR from 'swr'
import useI18n from 'Hooks/useI18n'

const RecentSearches = ({
  setQuery,
}: {
  setQuery: (query: string) => void
}) => {
  const { t } = useI18n()
  const user = useRecoilValue(userState)
  const [searchHistoryList, setSearchHistoryList] = useState<string[]>([])
  const [modalVisible, setModalVisible] = useState(false)
  const { data: tags } = useSWR(
    user?.user_id
      ? {
          endpoint: '/search/recent_history',
          user_id: user?.user_id,
        }
      : null,
    getRecentHistory
  )

  useEffect(() => {
    setSearchHistoryList(tags || [])
  }, [tags])

  const clearSearchHistory = async () => {
    await clearRecentHistory()
    setSearchHistoryList([])
    setModalVisible(false)
  }

  if (searchHistoryList.length === 0) return null

  return (
    <div className="m-2 pl-2">
      <div className="mb-4 flex items-center justify-between text-left text-sm">
        <span className="text-sm">{t('Recent Search')}</span>
        <DeleteOutlined onClick={() => setModalVisible(true)} />
      </div>
      <div className="flex flex-wrap gap-2">
        {searchHistoryList.map((tag) => (
          <button
            key={tag}
            className="flex items-center rounded-full border border-transparent bg-[rgba(255,255,255,0.2)] px-3 py-1 text-xs text-[rgba(255,255,255,0.7)] transition duration-500"
            onClick={() => {
              setQuery(tag)
            }}
          >
            {tag}
          </button>
        ))}
      </div>
      <TipsyModal
        open={modalVisible}
        onConfirm={() => {
          clearSearchHistory()
        }}
        onClose={() => {
          setModalVisible(false)
        }}
        title={t('Clear All Search Record')}
        desc={t('Are you sure to clear all search records?')}
        cancelText={t('Cancel')}
        confirmText={t('Clear')}
      />
    </div>
  )
}

export default RecentSearches
